import React, { useState, useRef } from "react";
import Header from "./header";
import { useSortableTable } from "./useSortableTable";
import { TablePagination } from "./tablePagination";
import { TableTitle } from "./tableTitle";
import { displayDesktopRowItem } from "./utils";
import Spinner from "react-bootstrap/Spinner";
import "./utils";
import "./style.scss";

const DataTable = (props) => {
  const tableBodyNode = useRef();
  const {
    tableBody,
    tableHeader,
    countTitle,
    displaySearchFilter,
    displaySectionTwo,
    searchFilterValue,
    handleSearchFilter,
    filteredTableList,
    isSelectAllChecked,
    isVerifierUser,
    parentComponent,
    actionsFormatter,
    selectAllItems,
    handleRowSelection,
    errorFlag,
    renderDesktopRows,
    isLoading = false,
  } = props;
  const [postsPerPage, setPostsPerPage] = useState(parentComponent == "productLookup" ? 25 : 10);
  const [currentPageButton, setCurrentPageButton] = useState(1);

  let filteredList;
  if (!filteredTableList) {
    filteredList = [];
  } else {
    filteredList = [...filteredTableList];
  }
  const { items, filteredItems, requestSort, sortConfig } = useSortableTable(tableBody, filteredList);
  const tdClass = "table-root__body__tr__td table-root__body__tr__td__text";

  let tableData = searchFilterValue && searchFilterValue !== "" && searchFilterValue.length > 0 ? filteredItems : items;

  /***********For Data table with pagination************/
  const numberOfPages = [];
  let currentData = displaySearchFilter ? [] : [...tableData];
  let howManyPages = 0;
  const indexOfLastPost = currentPageButton * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  currentData = tableData && tableData.slice(indexOfFirstPost, indexOfLastPost);
  if (tableData) {
    howManyPages = Math.ceil(tableData.length / postsPerPage);
  }

  for (let i = 1; i <= howManyPages; i++) {
    numberOfPages.push(i);
  }

  if (parentComponent === "productLookup") {
    tableBody?.sort((a, b) => {
      if (a.favourite === "TRUE" && b.favourite !== "TRUE") return -1;
      else if (a.favourite !== "TRUE" && b.favourite === "TRUE") return 1;

      if (a.category === b.category) {
        return a.manufacturer?.localeCompare(b.manufacturer);
      }
      return a.category?.localeCompare(b.category);
    });
  }

  const handleSelectAll = (e) => {
    selectAllItems(e);
  };

  const renderDefaultRows = () => {
    return currentData.map((row, idx) => {
      const { id } = row;
      return (
        <tr key={id ? id : idx} className={"table-root__body__tr"}>
          {tableHeader.map((col, index) => {
            return (
              <>
                {col.name !== "Checkbox" && col.name !== "Actions" && (
                  <td className={tdClass} key={index}>
                    <span>{displayDesktopRowItem(row, col)}</span>
                  </td>
                )}
                {col.name === "Actions" && (
                  <td key={index}>
                    <span>{actionsFormatter(row)}</span>
                  </td>
                )}

                {col.name === "Checkbox" && (
                  <td
                    className="table-root__body__tr__td table-root__body__tr__td__checkbox table-root__body__tr__td__fixed-row"
                    key={index}
                  >
                    <input
                      type="checkbox"
                      aria-label="Checkbox selection of rows"
                      className="table-root__body__tr__td__checkbox--input"
                      checked={row.isSelected}
                      onChange={() => handleRowSelection(row)}
                    />
                  </td>
                )}
              </>
            );
          })}
        </tr>
      );
    });
  };
  return (
    <div className="search-table-wrapper position-relative">
      {!displaySearchFilter && <div className="search-table-title">{countTitle}</div>}
      <div className="container-fluid search-table">
        <TableTitle
          countTitle={countTitle}
          searchResultsLength={
            tableData.length > 0 ? (tableData.length < 10 ? "0" + tableData.length : tableData.length) : "0"
          }
          searchFilterValue={searchFilterValue}
          handleSearchFilter={handleSearchFilter}
          displaySearchFilter={displaySearchFilter}
        />
        <div className="table-responsive customer-search__table position-relative">
          {isLoading && currentData.length > 0 && (
            <div
              className="position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ backgroundColor: "rgba(255, 255, 255, 0.6)", zIndex: 1 }}
            >
              <Spinner variant="secondary" style={{ width: 50, height: 50 }} />
            </div>
          )}
          <table id="example" className="table table-root">
            <Header
              tableHeader={tableHeader}
              isSelectAllChecked={isSelectAllChecked}
              handleSelectAll={handleSelectAll}
              sorting={sortConfig}
              onSorting={(field) => requestSort(field)}
              isSearchTable={displaySectionTwo}
              isLaborTable={parentComponent == "laborTable"}
              isVerifierUser={isVerifierUser}
            />
            <tbody className="table-root__body position-relative" ref={tableBodyNode}>
              {currentData.length > 0 ? (
                (renderDesktopRows ?? renderDefaultRows)(currentData)
              ) : (
                <tr>
                  <td colSpan={12}>
                    <div className="d-flex flex-column text-center" style={{ minHeight: 50 }}>
                      {isLoading ? (
                        <div className="position-absolute top-0 bottom-0 w-100 d-flex justify-content-center align-items-center">
                          <Spinner variant="secondary" style={{ width: 50, height: 50 }} />
                        </div>
                      ) : (
                        <>
                          <div className={"no-results--text" + (errorFlag ? " hasEror" : "")}>
                            {errorFlag
                              ? "An error occurred during your search. Please try again later."
                              : "No results found"}
                          </div>
                          <div className="no-results--info">
                            Try adjusting your search or filter to what you are looking for
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <TablePagination
          numberOfItems={tableData.length}
          numberOfPages={numberOfPages}
          currentPageButton={currentPageButton}
          setCurrentPageButton={setCurrentPageButton}
          postsPerPage={postsPerPage}
          setPostsPerPage={setPostsPerPage}
        />
      </div>
    </div>
  );
};

export default DataTable;
